function AddGuestIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      fill="#AEAAB5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h50v50H0z" />
      <path d="M26.773 25.727a7.364 7.364 0 100-14.727 7.364 7.364 0 000 14.727zM26.772 29.41c-11.23 0-14.727 7.363-14.727 7.363v3.682h29.454v-3.682s-3.497-7.364-14.727-7.364z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.311 24.938v6.312h2.104v-6.312h6.312v-2.104H9.415v-6.311H7.311v6.311H1v2.104h6.311z"
      />
    </svg>
  )
}

export default AddGuestIcon
